<script setup>
import { Moon, Sun } from 'lucide-vue-next';
</script>
<template>
  <ColorScheme>
    <button class="ml-auto" @click="$colorMode.preference = 'dark'" v-if="$colorMode.value === 'light'">
      <Sun />
    </button>
    <button class="ml-auto" @click="$colorMode.preference = 'light'" v-if="$colorMode.value === 'dark'">
      <Moon />
    </button>
  </ColorScheme>
</template>

<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
ul li {
  display: inline-block;
  padding: 5px;
}
p {
  margin: 0;
  padding-top: 5px;
  padding-bottom: 20px;
}
.feather {
  position: relative;
  top: 0px;
  cursor: pointer;
  padding: 7px;
  background-color: var(--bg-secondary);
  border: 2px solid var(--border-color);
  margin: 0;
  border-radius: 5px;
  transition: all 0.1s ease;
}
.feather:hover {
  top: -3px;
}
.preferred .feather {
  border-color: var(--color-primary);
  top: -3px;
}
.selected .feather {
  color: var(--color-primary);
}
</style>

